import React from "react";
import nextId from "react-id-generator";
import CustomDropdown from "../../Common/CustomDropdown/CustomDropdown";
import "./candidate-form.style.scss";
export default function CandidateForm({
  setDetails,
  loading,
  createContact,
  details,
  setCountryCode,
  countryCode
}) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        createContact();
      }}
      className="candidate-form-contact"
    >
      <h4>Send us a message</h4>
      <div className="fancy-input-wrapper">
        <span>Full name*</span>
        <input
          name="full_name"
          onChange={(e) =>
            setDetails({ ...details, [e.target.name]: e.target.value })
          }
          value={details.full_name}
          required
          placeholder=""
        />
      </div>
      <div className="fancy-input-wrapper">
        <span>Email*</span>
        <input
          type="email"
          name="email"
          onChange={(e) =>
            setDetails({ ...details, [e.target.name]: e.target.value })
          }
          value={details.email}
          required
          placeholder=""
          type="email"
        />
      </div>
      <div className="fancy-input-wrapper phone">
        <span>Mobile Number*</span>
          <div className="inner-wrapper">
            <div className="codes">
              <CustomDropdown
                sendClicked={(obj) => setCountryCode(obj.id)}
                selected={countryCode}
                list={codeList}
              />
            </div>
          <input
            name="mobile"
            onChange={(e) =>
              setDetails({ ...details, [e.target.name]: e.target.value })
            }
            value={details.mobile}
            pattern="^(\d){9,12}$"
            type="tel"
            placeholder="XXXXXXXXXX"
            required
          />
        </div>
      </div>
      <CustomDropdown
        sendClicked={(obj) => setDetails({ ...details, topic: obj.name })}
        list={questions}
        title="Choose Topic"
      />

      <div className="fancy-input-wrapper">
        <span>Your Comments*</span>
        <textarea
          name="comments"
          onChange={(e) =>
            setDetails({ ...details, [e.target.name]: e.target.value })
          }
          value={details.comments}
          placeholder=""
          required
        />
      </div>
      <div className="cf-footer">
        <button disabled={!details.topic} type="submit" className="cf-button">
          {loading ? "Submitting..." : "Submit"}
        </button>
      </div>
    </form>
  );
}

const questions = [{ id: "why", name: "What is AcadsHR", _id: nextId() }];

const codeList = [
  { keyId: nextId(), name: "+93 ", id: "+93" },
  { keyId: nextId(), name: "+355", id: "+355" },
  { keyId: nextId(), name: "+355", id: "+355" },
  { keyId: nextId(), name: "+374", id: "+374" },
  { keyId: nextId(), name: "+61", id: "+61" },
  { keyId: nextId(), name: "+43", id: "+43" },
  { keyId: nextId(), name: "+880", id: "+880" },
  { keyId: nextId(), name: "+32", id: "+32" },
  { keyId: nextId(), name: "+975", id: "+975	" },
  { keyId: nextId(), name: "+975", id: "+975" },
  { keyId: nextId(), name: "+1", id: "+1" },
  { keyId: nextId(), name: "+86", id: "+86" },
  { keyId: nextId(), name: "+503", id: "+503" },
  { keyId: nextId(), name: "+33", id: "+33" },
  { keyId: nextId(), name: "+49", id: "+49" },
  { keyId: nextId(), name: "+91", id: "+91" },
  { keyId: nextId(), name: "+972", id: "+972" },
  { keyId: nextId(), name: "+81", id: "+81" },
  { keyId: nextId(), name: "+64", id: "+64" },
  { keyId: nextId(), name: "+850", id: "+850" },
  { keyId: nextId(), name: "+7", id: "+7" },
];
